import {TokenData, UserAuthenticatedData} from '../interfaces/auth.interface';

export enum storageKeys {
  token = 'tokenData',
  user  = 'userData'
}

export const setTokenData = (tokenData: TokenData): void => {
  window.localStorage.setItem(storageKeys.token, JSON.stringify(tokenData));
};

export const getTokenData = (): TokenData => {
  const storageData = `${window.localStorage.getItem(storageKeys.token)}`;
  return JSON.parse(storageData);
};

export const setUserData = (userData: UserAuthenticatedData): void => {
  window.localStorage.setItem(storageKeys.user, JSON.stringify(userData));
};

export const getUserData = (): UserAuthenticatedData => {
  const storageData = `${window.localStorage.getItem(storageKeys.user)}`;
  return JSON.parse(storageData);
};

export const clearStorageData = (): void => {
  window.localStorage.clear();
};
